import React from 'react';
import { ScrollReveal } from './ScrollReveal';
export function TestimonialsSection() {
  const testimonials = [{
    quote: "Gained the clarity and stability to successfully sell my company. This work helped me realign my leadership from an embodied place, and now I'm connecting with my soul purpose for what's next.",
    author: 'Founder, Former CEO',
    className: ''
  }, {
    quote: 'Restructured my business so I could move abroad and run it with ease. I was running on empty, and the fear kept me trapped. Now I live as a digital nomad without my company collapsing.',
    author: 'CEO, Digital Nomad',
    className: ''
  }];
  return <section className="py-32 px-6 bg-slate text-cream relative overflow-hidden" data-id="element-123">
      {/* Subtle Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60rem] h-[60rem] bg-cream/3 rounded-full blur-3xl pointer-events-none" data-id="element-124" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-125">
        <ScrollReveal width="100%" className="mb-20 text-center" data-id="element-126">
          <span className="text-xs font-sans font-medium tracking-editorial text-cream/50 uppercase border-b border-cream/20 pb-2 inline-block" data-id="element-127">
            Proof
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-cream mt-8 leading-tight" data-id="element-128">
            The Women Who Chose Coherence Over Chaos
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-129">
          {testimonials.map((item, index) => <ScrollReveal key={index} delay={index * 0.2} className="w-full" data-id="element-130">
              <div className="bg-cream text-ink p-10 md:p-14 rounded-xl border border-ink/10 h-full flex flex-col justify-between relative" data-id="element-131">
                <div className="absolute top-6 left-6 text-6xl font-serif text-slate/10 leading-none" data-id="element-132">
                  "
                </div>
                <blockquote className="font-serif italic text-xl md:text-2xl leading-relaxed mb-10 relative z-10 text-slate-dark" data-id="element-133">
                  {item.quote}
                </blockquote>
                <div className="mt-auto relative z-10" data-id="element-134">
                  <cite className="not-italic block font-sans font-medium text-ink tracking-wide" data-id="element-135">
                    — {item.author}
                  </cite>
                </div>
              </div>
            </ScrollReveal>)}
        </div>

        {/* Authority Banner */}
        <ScrollReveal delay={0.4} width="100%" className="mt-16" data-id="element-136">
          <div className="text-center py-8 border-t border-b border-cream/10" data-id="element-137">
            <p className="font-sans text-xs tracking-editorial text-cream/40 uppercase mb-4" data-id="element-138">
              Trusted By Leaders In
            </p>
            <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 text-cream/30 font-sans text-sm tracking-wide" data-id="element-139">
              <span data-id="element-140">Cryptocurrency</span>
              <span className="hidden md:inline" data-id="element-141">·</span>
              <span data-id="element-142">Wellness</span>
              <span className="hidden md:inline" data-id="element-143">·</span>
              <span data-id="element-144">Coaching</span>
              <span className="hidden md:inline" data-id="element-145">·</span>
              <span data-id="element-146">Digital Business</span>
            </div>
          </div>
        </ScrollReveal>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-px bg-cream/10" data-id="element-147" />
    </section>;
}